import React from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';

class FieldAudio extends React.Component {

  constructor(props) {
    super(props);
    this.state = { play: false };
    this.audio = new Audio(props.url);
  }

  componentDidMount() {
    this.audio.addEventListener('ended', () => this.setState({ play: false }));
  }
  
  componentWillUnmount() {
    this.audio.removeEventListener('ended', () => this.setState({ play: false }));  
  }

  togglePlay = () => {
    this.state.play ? this.audio.pause() : this.audio.play();
    this.setState({ ...this.state, play: !this.state.play });
  }

  render() {
    if(!this.props.url) return null;
    return this.state.play ? <FaPause onClick={this.togglePlay} />
      : <FaPlay onClick={this.togglePlay} />;
  }
}
export default FieldAudio;